import React from "react"
import {Button} from "semantic-ui-react"
import PropTypes from "prop-types"

export default function ProductRowCartAction  ( { cart, product } )  {
	return (
		<Button
			onClick={() => {
				cart.remove( product )
			}}
			basic
			icon="cancel"
			size="tiny"
		/>
	)
}

ProductRowCartAction.propTypes = {
	cart:    PropTypes.object,
	product: PropTypes.object,
}





// WEBPACK FOOTER //
// ./src/components/Product/ProductRowCartAction.js